<template>
  <div id="workspace">
    <div class="bet_area">
      <div id="game_bets">
        <div v-for="line in sectors" :key="line.name" class="bet_line">
          <div></div>
          <div
              v-for="bet in line.bets"
              :key="bet.value"
              :class="'bet_cell '+bet.class+' '+checkIsSelected(bet.value)"
              @click="getBet(bet.value)"
          >
            {{bet.name}}
          </div>
          <div></div>
        </div>
      </div>
      <div class="controls_cont">
        <div>
          <div class="control_buttons">
            <div :class="'btn_risk '+checkRiskSelected(1)" @click="setRisk(1)">#1 Low Risk</div>
            <div :class="'btn_risk '+checkRiskSelected(2)" @click="setRisk(2)">#2 Normal Risk</div>
            <div :class="'btn_risk '+checkRiskSelected(3)" @click="setRisk(3)">#3 High Risk</div>
          </div>
          <div class="control_buttons">
            <div class="btn_ctrl" @click="randomPick(5)">Random bet</div>
            <div class="btn_ctrl" @click="addBet">Add bet</div>
            <div class="btn_ctrl" @click="clearBet">Clear bet</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {inject, provide} from "vue";
import GameService from '../../services/game.service';
import cashier from "@/services/cashier.service";

export default {
  name: "Lotto5",
  data () {
    return {
      bets_data: [],
      selected: [],
      cur_split_selected: [],
      pickCount: 0,
      risk: 1,
      pickMode: 'normal',
      sectors:
      [
        {
          name: "line1",
          bets:
          [
            {name: 1, value: '1', class: 'red', multiplier: '36', type: 'primitive'},
            {name: 2, value: '2', class: 'black', multiplier: '36', type: 'primitive'},
            {name: 3, value: '3', class: 'black', multiplier: '36', type: 'primitive'},
            {name: 4, value: '4', class: 'black', multiplier: '36', type: 'primitive'},
            {name: 5, value: '5', class: 'black', multiplier: '36', type: 'primitive'},
            {name: 6, value: '6', class: 'black', multiplier: '36', type: 'primitive'}
          ],

        },
        {
          name: "line2",
          bets:
          [
            {name: 7, value: '7', class: 'red', multiplier: '36', type: 'primitive'},
            {name: 8, value: '8', class: 'black', multiplier: '36', type: 'primitive'},
            {name: 9, value: '9', class: 'black', multiplier: '36', type: 'primitive'},
            {name: 10, value: '10', class: 'black', multiplier: '36', type: 'primitive'},
            {name: 11, value: '11', class: 'black', multiplier: '36', type: 'primitive'},
            {name: 12, value: '12', class: 'black', multiplier: '36', type: 'primitive'}
          ]
        },
        {
          name: "line3",
          bets:
              [
                {name: 13, value: '13', class: 'red', multiplier: '36', type: 'primitive'},
                {name: 14, value: '14', class: 'black', multiplier: '36', type: 'primitive'},
                {name: 15, value: '15', class: 'black', multiplier: '36', type: 'primitive'},
                {name: 16, value: '16', class: 'black', multiplier: '36', type: 'primitive'},
                {name: 17, value: '17', class: 'black', multiplier: '36', type: 'primitive'},
                {name: 18, value: '18', class: 'black', multiplier: '36', type: 'primitive'}
              ]
        },
        {
          name: "line4",
          bets:
              [
                {name: 19, value: '19', class: 'red', multiplier: '36', type: 'primitive'},
                {name: 20, value: '20', class: 'black', multiplier: '36', type: 'primitive'},
                {name: 21, value: '21', class: 'black', multiplier: '36', type: 'primitive'},
                {name: 22, value: '22', class: 'black', multiplier: '36', type: 'primitive'},
                {name: 23, value: '23', class: 'black', multiplier: '36', type: 'primitive'},
                {name: 24, value: '24', class: 'black', multiplier: '36', type: 'primitive'}
              ]
        },
        {
          name: "line5",
          bets:
              [
                {name: 25, value: '25', class: 'red', multiplier: '36', type: 'primitive'},
                {name: 26, value: '26', class: 'black', multiplier: '36', type: 'primitive'},
                {name: 27, value: '27', class: 'black', multiplier: '36', type: 'primitive'},
                {name: 28, value: '28', class: 'black', multiplier: '36', type: 'primitive'},
                {name: 29, value: '29', class: 'black', multiplier: '36', type: 'primitive'},
                {name: 30, value: '30', class: 'black', multiplier: '36', type: 'primitive'}
              ]
        },
        {
          name: "line6",
          bets:
              [
                {name: 31, value: '31', class: 'red', multiplier: '36', type: 'primitive'},
                {name: 32, value: '32', class: 'black', multiplier: '36', type: 'primitive'},
                {name: 33, value: '33', class: 'black', multiplier: '36', type: 'primitive'},
                {name: 34, value: '34', class: 'black', multiplier: '36', type: 'primitive'},
                {name: 35, value: '35', class: 'black', multiplier: '36', type: 'primitive'},
                {name: 36, value: '36', class: 'black', multiplier: '36', type: 'primitive'}
              ]
        }
      ],
      bet_aliases: []
    }
  },
  setup()
  {
    const game_kind = inject('gameKind')
    const game_alias = inject('gameAlias')
    const extra_bet = inject('gameExtra')
    const gameId = inject('gameId');
    return {
      game_kind,
      game_alias,
      extra_bet,
      gameId
    }
  },
  props: ['event', 'public_event', 'bet_value'],
  methods: {
    getBetApply(bet)
    {
      this.cur_split_selected = [];

      let found = '';

      for (let sel of this.selected)
      {
        if (sel.bet === bet)
        {
          found = sel;
        }
      }

      if (found !== '')
      {
        this.selected.splice(this.selected.indexOf(found), 1);
      }
      else
      {
        this.getBet(bet);
        this.addBet();
      }
    },
    getBet(bet)
    {
      if(this.event === '')
      {
        return;
      }

      let iter = 0;

      if(this.pickCount > 0)
      {
        this.cur_split_selected = [];
        iter = this.pickCount-1;
      }

      let even = this.event;

      let found = '';

      for (let sel of this.cur_split_selected)
      {
        if (sel.bet === bet)
        {
          found = sel;
        }
      }

      if (found !== '')
      {
        this.cur_split_selected.splice(this.cur_split_selected.indexOf(found), 1);
      }
      else
      {
        if(this.cur_split_selected.length < 5)
        {
          let over = 0;

          for(let i = 0; i <= iter; i++)
          {
            let bb = bet;

            if(this.pickMode === 'h')
            {
              bb = bb*1+i;

              if(over > 0)
              {
                bb = Math.floor(bb/10)*10-10+over;
              }

              if(Math.floor(bb/10) === bb/10 || over > 0)
              {
                over++;
              }
            }

            if(this.pickMode === 'v')
            {
              bb = bb*1+i*10;

              if(bb > 80 || over > 0)
              {
                over++;
              }
              if(over > 0)
              {
                bb = bb-80;
              }
            }

            bb = bb.toString();
            this.cur_split_selected.push({bet: bb, event: even});
          }
        }
      }
    },
    addBet()
    {
      if(this.cur_split_selected.length != 5)
      {
        return;
      }

      let bet_value = 'lotto5-'+this.risk;
      let bet = 'lotto5-'+this.risk;
      let bet_name = '';

      for(let sel of this.cur_split_selected)
      {
        if(bet_name !== '')
        {
          bet_name = bet_name + ';';
        }
        bet_name = bet_name + sel.bet;
        bet = bet + '_' + sel.bet;
      }

      let multiplier;
      multiplier = this.bets_data[bet_value]['max']

      this.selected.push({
        bet: bet,
        event: this.event,
        public_event: this.public_event,
        bet_value: this.bet_value,
        multiplier: multiplier,
        bet_name: bet_name,
        ntt: 'n'
      });

      this.$emit('getBet', this.selected);

      this.cur_split_selected = [];
    },
    clearBet()
    {
      this.cur_split_selected = [];
    },
    sortFn(a, b)
    {
      let fa = parseInt(a.bet),
          fb = parseInt(b.bet);

      if (fa < fb) {
        return -1;
      }
      if (fa > fb) {
        return 1;
      }
      return 0;
    },
    checkIsSelected(val)
    {
      let event = this.event;
      let ret = '';

      for(let sel of this.cur_split_selected)
      {
        if(sel.event === event)
        {
          if(sel.bet === val)
          {
            ret += 'selected ';
          }
        }
      }

      return ret;
    },
    setMode(mode, cnt)
    {
      if(mode !== 'normal' && cnt !== 0)
      {
        this.cur_split_selected = [];
      }

      if(mode === this.pickMode && cnt === this.pickCount)
      {
        this.pickMode = 'normal';
        this.pickCount = 0;
      }
      else
      {
        this.pickMode = mode;
        this.pickCount = cnt;
      }
    },
    clear_bet()
    {
      this.selected = [];
    },
    addBetEvent(event)
    {
      if (event.keyCode == 32)
      {
        event.preventDefault();
        this.addBet();
      }
    },
    getLottoBets()
    {
      cashier.getLottoBets(this.gameId).then(
          (response) => {
            this.bets_data = response.data;
          }
    );
    },
    setRisk(risk)
    {
      this.risk = risk;
    },
    checkRiskSelected(risk)
    {
      let crs = '';
      if(this.risk === risk)
      {
        crs = 'risk_selected';
      }
      return crs;
    },
    randomPick(cnt)
    {
      this.cur_split_selected = [];

      for(let i = 1; i <= cnt; i++)
      {
        let bet = Math.floor(Math.random() * 36+1).toString();
        let found = '';

        for (let sel of this.cur_split_selected)
        {
          if (sel.bet === bet)
          {
            found = sel;
          }
        }

        if (found === '')
        {
          this.cur_split_selected.push({
            bet: bet,
            event: this.event
          });
        }
        else
        {
          i--;
        }
      }
    }
  },
  mounted() {
    window.addEventListener('keyup', this.addBetEvent);
    this.getLottoBets();
  }
}
</script>

<style scoped>

  #workspace
  {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: cornflowerblue;
  }
  #game_bets
  {
    width: 100%;
    display: grid;
    grid-template-rows: 11% 11% 11% 11% 11% 11%;
  }
  .bet_area
  {
    height: 98%;
    width: 95%;
    display: grid;
    grid-template-rows: 85% 15%;
  }
  .controls_cont
  {
    display: grid;
    grid-template-rows: 50% 50%;
  }
  .bet_cell
  {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #DDDDDD;
    margin: 2px;
    cursor:pointer;
    font-size: 100%;
    font-weight: bold;
    background-color: darkgreen;
  }
  .selected
  {
    box-shadow: inset 0px 0px 0px 5px #53ea93;
    box-sizing: border-box;
    background-color: darkorchid;
    color: white;
  }
  .selected_shatters
  {
    background-color: darkkhaki;
    color: white;
  }
  .bet_line
  {
    width: 100%;
    display: grid;
    grid-template-columns: 26% 8% 8% 8% 8% 8% 8% 26%;
  }
  .bisque
  {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: aliceblue;
    color: black;
    margin: 5px;
    height: 30px;
    width: 30px;
    cursor: pointer;
  }
  .randoms
  {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .control_buttons
  {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .btn_ctrl
  {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: aliceblue;
    color: black;
    margin: 5px;
    height: 30px;
    width: 120px;
    cursor: pointer;
  }
  .btn_risk
  {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: aliceblue;
    color: black;
    margin: 5px;
    height: 30px;
    width: 120px;
    cursor: pointer;
  }
  .risk_selected
  {
    background-color: #8c918d;
  }
  .mb div
  {
    width: 8px;
    height: 8px;
    margin-left: 2px;
    background-color: darkgreen;
  }
  .mb
  {
    padding: 2px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid;
    border-radius: 5px;
    background-color: darkgray;
    cursor: pointer;
  }
  .hb
  {
    height: 30px;
    margin-left: 5px;
  }
  .vb
  {
    margin-top: 5px;
    width: 30px;
    margin-left: 5px;
    display: flex;
    flex-direction: column;
  }
  .vb div
  {
    margin-top: 2px;
  }
  .mbx
  {
    height: 30px;
    width: 30px;
    background-color: white;
    margin-left: 5px;
  }
  .selected_b
  {
    background-color: white;
  }
  .extras>div
  {
    display: flex;
    flex-direction: row;
    width: 50%;
  }
</style>